const setTimezone = ({ date, timezone }) =>
  new Date(date.toISOString().slice(0, -1) + timezone)

export default setTimezone
